import { render, staticRenderFns } from "./BaseUploadWithButton.vue?vue&type=template&id=36010dfd&scoped=true&"
import script from "./BaseUploadWithButton.vue?vue&type=script&lang=js&"
export * from "./BaseUploadWithButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadWithButton.vue?vue&type=style&index=0&id=36010dfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36010dfd",
  null
  
)

export default component.exports